export const InstanceStatus = {
  PENDING: 'pending',
  STARTING: 'starting',
  RUNNING: 'running',
  PAUSED: 'paused',
  COMPLETED: 'completed',
  FAILED: 'failed',
  STOPPED: 'stopped',
} as const;

export const SpawnMode = {
  SDK: 'sdk',
  CLI: 'cli',
  HOST: 'host',
  SSH: 'ssh',
  RELAY: 'relay',
  CORTEX_ENRICHED: 'cortex-enriched',
  LOCAL_LLM: 'local-llm',
} as const;

export type SpawnMode = (typeof SpawnMode)[keyof typeof SpawnMode];

export type InstanceStatus = (typeof InstanceStatus)[keyof typeof InstanceStatus];

export const InstanceEventType = {
  MESSAGE: 'message',
  TOOL_USE: 'tool_use',
  TOOL_RESULT: 'tool_result',
  ERROR: 'error',
  STATE_CHANGE: 'state_change',
  PROGRESS: 'progress',
} as const;

export type InstanceEventType = (typeof InstanceEventType)[keyof typeof InstanceEventType];

export interface Instance {
  id: string;
  projectId: string;
  agentId: string | null;
  taskId: string | null;
  teamId: string | null;
  runnerId: string | null;
  sshHostId: string | null;
  status: InstanceStatus;
  prompt: string | null;
  sessionId: string | null;
  model: string;
  runtime: string;
  workingDirectory: string | null;
  allowedTools: string[] | null;
  permissionMode: string;
  spawnMode: SpawnMode;
  maxTurns: number;
  maxBudgetUsd: number;
  currentTurn: number;
  totalTokens: number;
  totalCostUsd: number;
  pid: number | null;
  error: string | null;
  startedAt: string | null;
  pausedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
  agent?: { id: string; name: string; role: string };
  task?: { id: string; title: string; status: string } | null;
  project?: { id: string; name: string };
  recentEvents?: InstanceEvent[];
}

export interface InstanceEvent {
  id: string;
  instanceId: string;
  eventType: InstanceEventType;
  role: string | null;
  content: string | null;
  toolName: string | null;
  toolInput: Record<string, unknown> | null;
  tokens: number;
  durationMs: number;
  createdAt: string;
}

export interface CreateInstanceDto {
  agentId?: string;
  projectId?: string;
  runnerId?: string;
  taskId?: string;
  prompt?: string;
  model?: string;
  runtime?: string;
  workingDirectory?: string;
  allowedTools?: string[];
  permissionMode?: string;
  maxTurns?: number;
  maxBudgetUsd?: number;
  spawnMode?: SpawnMode;
  sshHostId?: string;
  autoRestart?: boolean;
  maxRetries?: number;
  cortexTaskId?: string;
  cortexProjectId?: string;
  skillIds?: string[];
}
